// extracted by mini-css-extract-plugin
export default {"CreateMainContainer":"CreateBucket_CreateMainContainer__HCMsU","firstChildDiv":"CreateBucket_firstChildDiv__q80vu","inputDiv":"CreateBucket_inputDiv__W235Z"};